import styles from 'styles/WhiteHatJrScreen.module.css'
import classNames from 'classnames'

import Reveal from 'reveal.js'

type WhiteHatJrScreenPropsType = {
  heading?: string;
  buttonText?: string;
  mascot?: string;
  classes?: any;
  slideTo?: number;
  isTeacher?: boolean;
  isOptionalActivitySkippedRef?: any;
}

function WhiteHatJrScreen({ heading, buttonText, mascot, classes, slideTo, isTeacher, isOptionalActivitySkippedRef }: WhiteHatJrScreenPropsType) {

  const onButtonClick = () =>{
    if(slideTo) {
      isOptionalActivitySkippedRef.current= true;
      Reveal.slide(slideTo);
    }
    else{
      Reveal.next();
    }
  }

  const onSkipClick = () =>{
    isOptionalActivitySkippedRef.current= false;
      Reveal.next();
  }

  return (
    <div className={styles.container}>
      <div className={classNames(styles.heading, classes.heading)}>
        { heading }
      </div>
      <div className={styles.imagesContainer}>
        <img
          src={mascot}
          alt='mascot'
          className={classNames(styles.image, classes.img)}
        />
      </div>
      { (buttonText && !!isTeacher) &&
        <div className={styles.btnWrapper}>
            <div className={classNames(styles.button, classes.button)} onClick={onButtonClick}>
                { buttonText }
            </div>
            <div className={classNames(styles.button, classes.button)} onClick={onSkipClick}>
                SKIP
            </div>
        </div>
       
      }
    </div>
  )
}

export default WhiteHatJrScreen
